// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "domains/vlp-notification/vlp-notification-admin-request-response.proto" (package "vlp.notification", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { NotificationMailProfileDTO } from "./vlp-notification-definition-model";
import { AlertSilenceDTO } from "./vlp-notification-delivery-model";
import { AlertIncidentDTO } from "./vlp-notification-delivery-model";
import { NotificationDeviceDTO } from "./vlp-notification-delivery-model";
import { NotificationDeliveryDTO } from "./vlp-notification-delivery-model";
import { NotificationMessageDTO } from "./vlp-notification-delivery-model";
import { NotificationPreferenceDTO } from "./vlp-notification-definition-model";
import { NotificationTemplateDTO } from "./vlp-notification-definition-model";
import { NotificationRecipientRuleDTO } from "./vlp-notification-definition-model";
import { NotificationRuleDTO } from "./vlp-notification-definition-model";
import { NotificationDefinitionDTO } from "./vlp-notification-definition-model";
import { ActionResponse } from "../../common";
import { eNotificationChannel } from "./vlp-notification-definition-model";
import { eAlertIncidentState } from "./vlp-notification-delivery-model";
import { eNotificationSeverity } from "./vlp-notification-definition-model";
import { eNotificationCategory } from "./vlp-notification-definition-model";
// =====================================================================
// LUL-653 — Notification admin + inbox APIs. TenantId/AccountId lấy từ JWT
// claim phía server; rule tenant/unit override chỉ sửa được trong tenant của mình
// (platform default rule tenant_id=0 chỉ Platform Ops sửa).
// =====================================================================

/**
 * @generated from protobuf message vlp.notification.NotificationIdRequest
 */
export interface NotificationIdRequest {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message vlp.notification.ListNotificationDefinitionsRequest
 */
export interface ListNotificationDefinitionsRequest {
    /**
     * @generated from protobuf field: vlp.notification.eNotificationCategory category = 1
     */
    category: eNotificationCategory; // UNSPECIFIED = tất cả
    /**
     * @generated from protobuf field: bool include_archived = 2
     */
    includeArchived: boolean;
}
/**
 * @generated from protobuf message vlp.notification.ListNotificationRulesRequest
 */
export interface ListNotificationRulesRequest {
    /**
     * @generated from protobuf field: int64 notification_definition_id = 1
     */
    notificationDefinitionId: number; // 0 = tất cả
    /**
     * @generated from protobuf field: bool include_platform_defaults = 2
     */
    includePlatformDefaults: boolean;
}
/**
 * @generated from protobuf message vlp.notification.ListNotificationTemplatesRequest
 */
export interface ListNotificationTemplatesRequest {
    /**
     * @generated from protobuf field: int64 notification_definition_id = 1
     */
    notificationDefinitionId: number;
}
/**
 * Inbox người dùng hiện tại (account từ JWT).
 *
 * @generated from protobuf message vlp.notification.ListMyNotificationsRequest
 */
export interface ListMyNotificationsRequest {
    /**
     * @generated from protobuf field: bool unread_only = 1
     */
    unreadOnly: boolean;
    /**
     * @generated from protobuf field: int32 skip = 2
     */
    skip: number;
    /**
     * @generated from protobuf field: int32 take = 3
     */
    take: number; // 0 = mặc định 50
    /**
     * @generated from protobuf field: string keyword = 4
     */
    keyword: string;
    /**
     * @generated from protobuf field: bool read_only = 5
     */
    readOnly: boolean;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationSeverity severity = 6
     */
    severity: eNotificationSeverity; // UNSPECIFIED = tất cả
    /**
     * @generated from protobuf field: string definition_code = 7
     */
    definitionCode: string; // rỗng = tất cả loại thông báo
}
/**
 * @generated from protobuf message vlp.notification.MarkNotificationReadRequest
 */
export interface MarkNotificationReadRequest {
    /**
     * @generated from protobuf field: int64 notification_delivery_id = 1
     */
    notificationDeliveryId: number; // 0 + mark_all=true = đánh dấu tất cả
    /**
     * @generated from protobuf field: bool mark_all = 2
     */
    markAll: boolean;
}
/**
 * @generated from protobuf message vlp.notification.DeleteMyReadNotificationsRequest
 */
export interface DeleteMyReadNotificationsRequest {
}
/**
 * @generated from protobuf message vlp.notification.NotificationInboxTypeOptionDTO
 */
export interface NotificationInboxTypeOptionDTO {
    /**
     * @generated from protobuf field: string definition_code = 1
     */
    definitionCode: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * Thiết bị push của CHÍNH người gọi. AccountId/TenantId lấy từ claim phía server — client KHÔNG
 * gửi lên, nếu không thì bất kỳ ai cũng ghi được token vào hòm thư người khác.
 *
 * @generated from protobuf message vlp.notification.RegisterMyPushDeviceRequest
 */
export interface RegisterMyPushDeviceRequest {
    /**
     * @generated from protobuf field: string push_token = 1
     */
    pushToken: string; // ExpoPushToken[...] do expo-notifications cấp
    /**
     * @generated from protobuf field: string platform = 2
     */
    platform: string; // ios | android
    /**
     * @generated from protobuf field: string device_name = 3
     */
    deviceName: string;
    /**
     * @generated from protobuf field: string app_version = 4
     */
    appVersion: string;
}
/**
 * Gọi TRƯỚC khi đăng xuất. Không gọi thì máy đó vẫn nhận push của tài khoản vừa rời đi.
 *
 * @generated from protobuf message vlp.notification.UnregisterMyPushDeviceRequest
 */
export interface UnregisterMyPushDeviceRequest {
    /**
     * @generated from protobuf field: string push_token = 1
     */
    pushToken: string;
}
/**
 * @generated from protobuf message vlp.notification.ListDeliveryHistoryRequest
 */
export interface ListDeliveryHistoryRequest {
    /**
     * @generated from protobuf field: int64 notification_message_id = 1
     */
    notificationMessageId: number; // 0 = filter theo definition/time
    /**
     * @generated from protobuf field: int64 notification_definition_id = 2
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: int32 skip = 3
     */
    skip: number;
    /**
     * @generated from protobuf field: int32 take = 4
     */
    take: number;
}
/**
 * @generated from protobuf message vlp.notification.ListAlertIncidentsRequest
 */
export interface ListAlertIncidentsRequest {
    /**
     * @generated from protobuf field: vlp.notification.eAlertIncidentState state = 1
     */
    state: eAlertIncidentState; // UNSPECIFIED = tất cả
    /**
     * @generated from protobuf field: vlp.notification.eNotificationSeverity severity = 2
     */
    severity: eNotificationSeverity;
    /**
     * @generated from protobuf field: int32 skip = 3
     */
    skip: number;
    /**
     * @generated from protobuf field: int32 take = 4
     */
    take: number;
}
/**
 * @generated from protobuf message vlp.notification.AcknowledgeIncidentRequest
 */
export interface AcknowledgeIncidentRequest {
    /**
     * @generated from protobuf field: int64 alert_incident_id = 1
     */
    alertIncidentId: number;
    /**
     * @generated from protobuf field: string note = 2
     */
    note: string;
}
/**
 * @generated from protobuf message vlp.notification.ResolveIncidentRequest
 */
export interface ResolveIncidentRequest {
    /**
     * @generated from protobuf field: int64 alert_incident_id = 1
     */
    alertIncidentId: number;
    /**
     * @generated from protobuf field: string resolution = 2
     */
    resolution: string;
    /**
     * @generated from protobuf field: string rca_reference = 3
     */
    rcaReference: string;
}
/**
 * Test-send: gửi thử template tới CHÍNH người gọi (không đụng production recipients — AC 10).
 *
 * @generated from protobuf message vlp.notification.TestSendNotificationRequest
 */
export interface TestSendNotificationRequest {
    /**
     * @generated from protobuf field: int64 notification_definition_id = 1
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationChannel channel = 2
     */
    channel: eNotificationChannel;
    /**
     * @generated from protobuf field: string language = 3
     */
    language: string;
    /**
     * @generated from protobuf field: string sample_payload_json = 4
     */
    samplePayloadJson: string;
}
/**
 * @generated from protobuf message vlp.notification.NotificationDefinitionResponse
 */
export interface NotificationDefinitionResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationDefinitionDTO data = 2
     */
    data?: NotificationDefinitionDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationDefinitionListResponse
 */
export interface NotificationDefinitionListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationDefinitionDTO items = 2
     */
    items: NotificationDefinitionDTO[];
}
/**
 * @generated from protobuf message vlp.notification.NotificationRuleResponse
 */
export interface NotificationRuleResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationRuleDTO data = 2
     */
    data?: NotificationRuleDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationRuleListResponse
 */
export interface NotificationRuleListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationRuleDTO items = 2
     */
    items: NotificationRuleDTO[];
}
/**
 * @generated from protobuf message vlp.notification.NotificationRecipientRuleResponse
 */
export interface NotificationRecipientRuleResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationRecipientRuleDTO data = 2
     */
    data?: NotificationRecipientRuleDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationTemplateResponse
 */
export interface NotificationTemplateResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationTemplateDTO data = 2
     */
    data?: NotificationTemplateDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationTemplateListResponse
 */
export interface NotificationTemplateListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationTemplateDTO items = 2
     */
    items: NotificationTemplateDTO[];
}
/**
 * @generated from protobuf message vlp.notification.NotificationPreferenceResponse
 */
export interface NotificationPreferenceResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationPreferenceDTO data = 2
     */
    data?: NotificationPreferenceDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationPreferenceListResponse
 */
export interface NotificationPreferenceListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationPreferenceDTO items = 2
     */
    items: NotificationPreferenceDTO[];
}
/**
 * @generated from protobuf message vlp.notification.MyNotificationsResponse
 */
export interface MyNotificationsResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationMessageDTO items = 2
     */
    items: NotificationMessageDTO[];
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationDeliveryDTO deliveries = 3
     */
    deliveries: NotificationDeliveryDTO[]; // delivery in-app tương ứng (IsRead/ReadAt)
    /**
     * @generated from protobuf field: int32 unread_count = 4
     */
    unreadCount: number;
    /**
     * @generated from protobuf field: int32 total_count = 5
     */
    totalCount: number;
    /**
     * @generated from protobuf field: int32 read_count = 6
     */
    readCount: number;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationInboxTypeOptionDTO type_options = 7
     */
    typeOptions: NotificationInboxTypeOptionDTO[];
}
/**
 * @generated from protobuf message vlp.notification.MarkNotificationReadResponse
 */
export interface MarkNotificationReadResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: int32 marked_count = 2
     */
    markedCount: number;
    /**
     * @generated from protobuf field: int32 unread_count = 3
     */
    unreadCount: number;
}
/**
 * @generated from protobuf message vlp.notification.DeleteMyReadNotificationsResponse
 */
export interface DeleteMyReadNotificationsResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: int32 deleted_count = 2
     */
    deletedCount: number;
    /**
     * @generated from protobuf field: int32 unread_count = 3
     */
    unreadCount: number;
    /**
     * @generated from protobuf field: int32 read_count = 4
     */
    readCount: number;
}
/**
 * @generated from protobuf message vlp.notification.NotificationDeviceResponse
 */
export interface NotificationDeviceResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationDeviceDTO data = 2
     */
    data?: NotificationDeviceDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationDeliveryListResponse
 */
export interface NotificationDeliveryListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationDeliveryDTO items = 2
     */
    items: NotificationDeliveryDTO[];
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message vlp.notification.AlertIncidentResponse
 */
export interface AlertIncidentResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.AlertIncidentDTO data = 2
     */
    data?: AlertIncidentDTO;
}
/**
 * @generated from protobuf message vlp.notification.AlertIncidentListResponse
 */
export interface AlertIncidentListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.AlertIncidentDTO items = 2
     */
    items: AlertIncidentDTO[];
    /**
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message vlp.notification.AlertSilenceResponse
 */
export interface AlertSilenceResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.AlertSilenceDTO data = 2
     */
    data?: AlertSilenceDTO;
}
/**
 * @generated from protobuf message vlp.notification.AlertSilenceListResponse
 */
export interface AlertSilenceListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.AlertSilenceDTO items = 2
     */
    items: AlertSilenceDTO[];
}
/**
 * @generated from protobuf message vlp.notification.TestSendNotificationResponse
 */
export interface TestSendNotificationResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: string rendered_subject = 2
     */
    renderedSubject: string;
    /**
     * @generated from protobuf field: string rendered_body = 3
     */
    renderedBody: string;
}
/**
 * @generated from protobuf message vlp.notification.ListNotificationMailProfilesRequest
 */
export interface ListNotificationMailProfilesRequest {
    /**
     * @generated from protobuf field: int64 organization_unit_id = 1
     */
    organizationUnitId: number; // 0 = all scopes visible to caller
    /**
     * @generated from protobuf field: bool include_disabled = 2
     */
    includeDisabled: boolean;
}
/**
 * @generated from protobuf message vlp.notification.SaveNotificationMailCredentialRequest
 */
export interface SaveNotificationMailCredentialRequest {
    /**
     * @generated from protobuf field: int64 notification_mail_profile_id = 1
     */
    notificationMailProfileId: number;
    /**
     * @generated from protobuf field: string password = 2
     */
    password: string; // write-only
}
/**
 * @generated from protobuf message vlp.notification.TestNotificationMailProfileRequest
 */
export interface TestNotificationMailProfileRequest {
    /**
     * @generated from protobuf field: int64 notification_mail_profile_id = 1
     */
    notificationMailProfileId: number;
    /**
     * @generated from protobuf field: bool send_test_message = 2
     */
    sendTestMessage: boolean;
}
/**
 * @generated from protobuf message vlp.notification.NotificationMailProfileResponse
 */
export interface NotificationMailProfileResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: vlp.notification.NotificationMailProfileDTO data = 2
     */
    data?: NotificationMailProfileDTO;
}
/**
 * @generated from protobuf message vlp.notification.NotificationMailProfileListResponse
 */
export interface NotificationMailProfileListResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationMailProfileDTO items = 2
     */
    items: NotificationMailProfileDTO[];
}
/**
 * @generated from protobuf message vlp.notification.TestNotificationMailProfileResponse
 */
export interface TestNotificationMailProfileResponse {
    /**
     * @generated from protobuf field: common.ActionResponse status = 1
     */
    status?: ActionResponse;
    /**
     * @generated from protobuf field: string result_code = 2
     */
    resultCode: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class NotificationIdRequest$Type extends MessageType<NotificationIdRequest> {
    constructor() {
        super("vlp.notification.NotificationIdRequest", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<NotificationIdRequest>): NotificationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<NotificationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationIdRequest): NotificationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int64(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationIdRequest
 */
export const NotificationIdRequest = new NotificationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNotificationDefinitionsRequest$Type extends MessageType<ListNotificationDefinitionsRequest> {
    constructor() {
        super("vlp.notification.ListNotificationDefinitionsRequest", [
            { no: 1, name: "category", kind: "enum", T: () => ["vlp.notification.eNotificationCategory", eNotificationCategory] },
            { no: 2, name: "include_archived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListNotificationDefinitionsRequest>): ListNotificationDefinitionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.category = 0;
        message.includeArchived = false;
        if (value !== undefined)
            reflectionMergePartial<ListNotificationDefinitionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListNotificationDefinitionsRequest): ListNotificationDefinitionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* vlp.notification.eNotificationCategory category */ 1:
                    message.category = reader.int32();
                    break;
                case /* bool include_archived */ 2:
                    message.includeArchived = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListNotificationDefinitionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* vlp.notification.eNotificationCategory category = 1; */
        if (message.category !== 0)
            writer.tag(1, WireType.Varint).int32(message.category);
        /* bool include_archived = 2; */
        if (message.includeArchived !== false)
            writer.tag(2, WireType.Varint).bool(message.includeArchived);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListNotificationDefinitionsRequest
 */
export const ListNotificationDefinitionsRequest = new ListNotificationDefinitionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNotificationRulesRequest$Type extends MessageType<ListNotificationRulesRequest> {
    constructor() {
        super("vlp.notification.ListNotificationRulesRequest", [
            { no: 1, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "include_platform_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListNotificationRulesRequest>): ListNotificationRulesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDefinitionId = 0;
        message.includePlatformDefaults = false;
        if (value !== undefined)
            reflectionMergePartial<ListNotificationRulesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListNotificationRulesRequest): ListNotificationRulesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_definition_id */ 1:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* bool include_platform_defaults */ 2:
                    message.includePlatformDefaults = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListNotificationRulesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_definition_id = 1; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDefinitionId);
        /* bool include_platform_defaults = 2; */
        if (message.includePlatformDefaults !== false)
            writer.tag(2, WireType.Varint).bool(message.includePlatformDefaults);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListNotificationRulesRequest
 */
export const ListNotificationRulesRequest = new ListNotificationRulesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNotificationTemplatesRequest$Type extends MessageType<ListNotificationTemplatesRequest> {
    constructor() {
        super("vlp.notification.ListNotificationTemplatesRequest", [
            { no: 1, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<ListNotificationTemplatesRequest>): ListNotificationTemplatesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDefinitionId = 0;
        if (value !== undefined)
            reflectionMergePartial<ListNotificationTemplatesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListNotificationTemplatesRequest): ListNotificationTemplatesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_definition_id */ 1:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListNotificationTemplatesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_definition_id = 1; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDefinitionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListNotificationTemplatesRequest
 */
export const ListNotificationTemplatesRequest = new ListNotificationTemplatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMyNotificationsRequest$Type extends MessageType<ListMyNotificationsRequest> {
    constructor() {
        super("vlp.notification.ListMyNotificationsRequest", [
            { no: 1, name: "unread_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "skip", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "take", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "keyword", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "read_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "severity", kind: "enum", T: () => ["vlp.notification.eNotificationSeverity", eNotificationSeverity] },
            { no: 7, name: "definition_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListMyNotificationsRequest>): ListMyNotificationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.unreadOnly = false;
        message.skip = 0;
        message.take = 0;
        message.keyword = "";
        message.readOnly = false;
        message.severity = 0;
        message.definitionCode = "";
        if (value !== undefined)
            reflectionMergePartial<ListMyNotificationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMyNotificationsRequest): ListMyNotificationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool unread_only */ 1:
                    message.unreadOnly = reader.bool();
                    break;
                case /* int32 skip */ 2:
                    message.skip = reader.int32();
                    break;
                case /* int32 take */ 3:
                    message.take = reader.int32();
                    break;
                case /* string keyword */ 4:
                    message.keyword = reader.string();
                    break;
                case /* bool read_only */ 5:
                    message.readOnly = reader.bool();
                    break;
                case /* vlp.notification.eNotificationSeverity severity */ 6:
                    message.severity = reader.int32();
                    break;
                case /* string definition_code */ 7:
                    message.definitionCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMyNotificationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool unread_only = 1; */
        if (message.unreadOnly !== false)
            writer.tag(1, WireType.Varint).bool(message.unreadOnly);
        /* int32 skip = 2; */
        if (message.skip !== 0)
            writer.tag(2, WireType.Varint).int32(message.skip);
        /* int32 take = 3; */
        if (message.take !== 0)
            writer.tag(3, WireType.Varint).int32(message.take);
        /* string keyword = 4; */
        if (message.keyword !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.keyword);
        /* bool read_only = 5; */
        if (message.readOnly !== false)
            writer.tag(5, WireType.Varint).bool(message.readOnly);
        /* vlp.notification.eNotificationSeverity severity = 6; */
        if (message.severity !== 0)
            writer.tag(6, WireType.Varint).int32(message.severity);
        /* string definition_code = 7; */
        if (message.definitionCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.definitionCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListMyNotificationsRequest
 */
export const ListMyNotificationsRequest = new ListMyNotificationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkNotificationReadRequest$Type extends MessageType<MarkNotificationReadRequest> {
    constructor() {
        super("vlp.notification.MarkNotificationReadRequest", [
            { no: 1, name: "notification_delivery_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "mark_all", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MarkNotificationReadRequest>): MarkNotificationReadRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDeliveryId = 0;
        message.markAll = false;
        if (value !== undefined)
            reflectionMergePartial<MarkNotificationReadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MarkNotificationReadRequest): MarkNotificationReadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_delivery_id */ 1:
                    message.notificationDeliveryId = reader.int64().toNumber();
                    break;
                case /* bool mark_all */ 2:
                    message.markAll = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MarkNotificationReadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_delivery_id = 1; */
        if (message.notificationDeliveryId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDeliveryId);
        /* bool mark_all = 2; */
        if (message.markAll !== false)
            writer.tag(2, WireType.Varint).bool(message.markAll);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.MarkNotificationReadRequest
 */
export const MarkNotificationReadRequest = new MarkNotificationReadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMyReadNotificationsRequest$Type extends MessageType<DeleteMyReadNotificationsRequest> {
    constructor() {
        super("vlp.notification.DeleteMyReadNotificationsRequest", []);
    }
    create(value?: PartialMessage<DeleteMyReadNotificationsRequest>): DeleteMyReadNotificationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteMyReadNotificationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteMyReadNotificationsRequest): DeleteMyReadNotificationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteMyReadNotificationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.DeleteMyReadNotificationsRequest
 */
export const DeleteMyReadNotificationsRequest = new DeleteMyReadNotificationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationInboxTypeOptionDTO$Type extends MessageType<NotificationInboxTypeOptionDTO> {
    constructor() {
        super("vlp.notification.NotificationInboxTypeOptionDTO", [
            { no: 1, name: "definition_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<NotificationInboxTypeOptionDTO>): NotificationInboxTypeOptionDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.definitionCode = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<NotificationInboxTypeOptionDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationInboxTypeOptionDTO): NotificationInboxTypeOptionDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string definition_code */ 1:
                    message.definitionCode = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationInboxTypeOptionDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string definition_code = 1; */
        if (message.definitionCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.definitionCode);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationInboxTypeOptionDTO
 */
export const NotificationInboxTypeOptionDTO = new NotificationInboxTypeOptionDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterMyPushDeviceRequest$Type extends MessageType<RegisterMyPushDeviceRequest> {
    constructor() {
        super("vlp.notification.RegisterMyPushDeviceRequest", [
            { no: 1, name: "push_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "device_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RegisterMyPushDeviceRequest>): RegisterMyPushDeviceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pushToken = "";
        message.platform = "";
        message.deviceName = "";
        message.appVersion = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterMyPushDeviceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterMyPushDeviceRequest): RegisterMyPushDeviceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string push_token */ 1:
                    message.pushToken = reader.string();
                    break;
                case /* string platform */ 2:
                    message.platform = reader.string();
                    break;
                case /* string device_name */ 3:
                    message.deviceName = reader.string();
                    break;
                case /* string app_version */ 4:
                    message.appVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterMyPushDeviceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string push_token = 1; */
        if (message.pushToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pushToken);
        /* string platform = 2; */
        if (message.platform !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.platform);
        /* string device_name = 3; */
        if (message.deviceName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.deviceName);
        /* string app_version = 4; */
        if (message.appVersion !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.RegisterMyPushDeviceRequest
 */
export const RegisterMyPushDeviceRequest = new RegisterMyPushDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnregisterMyPushDeviceRequest$Type extends MessageType<UnregisterMyPushDeviceRequest> {
    constructor() {
        super("vlp.notification.UnregisterMyPushDeviceRequest", [
            { no: 1, name: "push_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UnregisterMyPushDeviceRequest>): UnregisterMyPushDeviceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pushToken = "";
        if (value !== undefined)
            reflectionMergePartial<UnregisterMyPushDeviceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnregisterMyPushDeviceRequest): UnregisterMyPushDeviceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string push_token */ 1:
                    message.pushToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnregisterMyPushDeviceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string push_token = 1; */
        if (message.pushToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pushToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.UnregisterMyPushDeviceRequest
 */
export const UnregisterMyPushDeviceRequest = new UnregisterMyPushDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeliveryHistoryRequest$Type extends MessageType<ListDeliveryHistoryRequest> {
    constructor() {
        super("vlp.notification.ListDeliveryHistoryRequest", [
            { no: 1, name: "notification_message_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "skip", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "take", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListDeliveryHistoryRequest>): ListDeliveryHistoryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationMessageId = 0;
        message.notificationDefinitionId = 0;
        message.skip = 0;
        message.take = 0;
        if (value !== undefined)
            reflectionMergePartial<ListDeliveryHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListDeliveryHistoryRequest): ListDeliveryHistoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_message_id */ 1:
                    message.notificationMessageId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 2:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* int32 skip */ 3:
                    message.skip = reader.int32();
                    break;
                case /* int32 take */ 4:
                    message.take = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListDeliveryHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_message_id = 1; */
        if (message.notificationMessageId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationMessageId);
        /* int64 notification_definition_id = 2; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(2, WireType.Varint).int64(message.notificationDefinitionId);
        /* int32 skip = 3; */
        if (message.skip !== 0)
            writer.tag(3, WireType.Varint).int32(message.skip);
        /* int32 take = 4; */
        if (message.take !== 0)
            writer.tag(4, WireType.Varint).int32(message.take);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListDeliveryHistoryRequest
 */
export const ListDeliveryHistoryRequest = new ListDeliveryHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAlertIncidentsRequest$Type extends MessageType<ListAlertIncidentsRequest> {
    constructor() {
        super("vlp.notification.ListAlertIncidentsRequest", [
            { no: 1, name: "state", kind: "enum", T: () => ["vlp.notification.eAlertIncidentState", eAlertIncidentState] },
            { no: 2, name: "severity", kind: "enum", T: () => ["vlp.notification.eNotificationSeverity", eNotificationSeverity] },
            { no: 3, name: "skip", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "take", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListAlertIncidentsRequest>): ListAlertIncidentsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = 0;
        message.severity = 0;
        message.skip = 0;
        message.take = 0;
        if (value !== undefined)
            reflectionMergePartial<ListAlertIncidentsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAlertIncidentsRequest): ListAlertIncidentsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* vlp.notification.eAlertIncidentState state */ 1:
                    message.state = reader.int32();
                    break;
                case /* vlp.notification.eNotificationSeverity severity */ 2:
                    message.severity = reader.int32();
                    break;
                case /* int32 skip */ 3:
                    message.skip = reader.int32();
                    break;
                case /* int32 take */ 4:
                    message.take = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAlertIncidentsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* vlp.notification.eAlertIncidentState state = 1; */
        if (message.state !== 0)
            writer.tag(1, WireType.Varint).int32(message.state);
        /* vlp.notification.eNotificationSeverity severity = 2; */
        if (message.severity !== 0)
            writer.tag(2, WireType.Varint).int32(message.severity);
        /* int32 skip = 3; */
        if (message.skip !== 0)
            writer.tag(3, WireType.Varint).int32(message.skip);
        /* int32 take = 4; */
        if (message.take !== 0)
            writer.tag(4, WireType.Varint).int32(message.take);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListAlertIncidentsRequest
 */
export const ListAlertIncidentsRequest = new ListAlertIncidentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcknowledgeIncidentRequest$Type extends MessageType<AcknowledgeIncidentRequest> {
    constructor() {
        super("vlp.notification.AcknowledgeIncidentRequest", [
            { no: 1, name: "alert_incident_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AcknowledgeIncidentRequest>): AcknowledgeIncidentRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertIncidentId = 0;
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial<AcknowledgeIncidentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcknowledgeIncidentRequest): AcknowledgeIncidentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 alert_incident_id */ 1:
                    message.alertIncidentId = reader.int64().toNumber();
                    break;
                case /* string note */ 2:
                    message.note = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcknowledgeIncidentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 alert_incident_id = 1; */
        if (message.alertIncidentId !== 0)
            writer.tag(1, WireType.Varint).int64(message.alertIncidentId);
        /* string note = 2; */
        if (message.note !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.note);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AcknowledgeIncidentRequest
 */
export const AcknowledgeIncidentRequest = new AcknowledgeIncidentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveIncidentRequest$Type extends MessageType<ResolveIncidentRequest> {
    constructor() {
        super("vlp.notification.ResolveIncidentRequest", [
            { no: 1, name: "alert_incident_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "resolution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rca_reference", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResolveIncidentRequest>): ResolveIncidentRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertIncidentId = 0;
        message.resolution = "";
        message.rcaReference = "";
        if (value !== undefined)
            reflectionMergePartial<ResolveIncidentRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResolveIncidentRequest): ResolveIncidentRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 alert_incident_id */ 1:
                    message.alertIncidentId = reader.int64().toNumber();
                    break;
                case /* string resolution */ 2:
                    message.resolution = reader.string();
                    break;
                case /* string rca_reference */ 3:
                    message.rcaReference = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResolveIncidentRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 alert_incident_id = 1; */
        if (message.alertIncidentId !== 0)
            writer.tag(1, WireType.Varint).int64(message.alertIncidentId);
        /* string resolution = 2; */
        if (message.resolution !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resolution);
        /* string rca_reference = 3; */
        if (message.rcaReference !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rcaReference);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ResolveIncidentRequest
 */
export const ResolveIncidentRequest = new ResolveIncidentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSendNotificationRequest$Type extends MessageType<TestSendNotificationRequest> {
    constructor() {
        super("vlp.notification.TestSendNotificationRequest", [
            { no: 1, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "channel", kind: "enum", T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 3, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sample_payload_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestSendNotificationRequest>): TestSendNotificationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDefinitionId = 0;
        message.channel = 0;
        message.language = "";
        message.samplePayloadJson = "";
        if (value !== undefined)
            reflectionMergePartial<TestSendNotificationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestSendNotificationRequest): TestSendNotificationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_definition_id */ 1:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationChannel channel */ 2:
                    message.channel = reader.int32();
                    break;
                case /* string language */ 3:
                    message.language = reader.string();
                    break;
                case /* string sample_payload_json */ 4:
                    message.samplePayloadJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestSendNotificationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_definition_id = 1; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDefinitionId);
        /* vlp.notification.eNotificationChannel channel = 2; */
        if (message.channel !== 0)
            writer.tag(2, WireType.Varint).int32(message.channel);
        /* string language = 3; */
        if (message.language !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.language);
        /* string sample_payload_json = 4; */
        if (message.samplePayloadJson !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.samplePayloadJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.TestSendNotificationRequest
 */
export const TestSendNotificationRequest = new TestSendNotificationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDefinitionResponse$Type extends MessageType<NotificationDefinitionResponse> {
    constructor() {
        super("vlp.notification.NotificationDefinitionResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationDefinitionDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationDefinitionResponse>): NotificationDefinitionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationDefinitionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDefinitionResponse): NotificationDefinitionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationDefinitionDTO data */ 2:
                    message.data = NotificationDefinitionDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDefinitionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationDefinitionDTO data = 2; */
        if (message.data)
            NotificationDefinitionDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDefinitionResponse
 */
export const NotificationDefinitionResponse = new NotificationDefinitionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDefinitionListResponse$Type extends MessageType<NotificationDefinitionListResponse> {
    constructor() {
        super("vlp.notification.NotificationDefinitionListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationDefinitionDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationDefinitionListResponse>): NotificationDefinitionListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<NotificationDefinitionListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDefinitionListResponse): NotificationDefinitionListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationDefinitionDTO items */ 2:
                    message.items.push(NotificationDefinitionDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDefinitionListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationDefinitionDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationDefinitionDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDefinitionListResponse
 */
export const NotificationDefinitionListResponse = new NotificationDefinitionListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationRuleResponse$Type extends MessageType<NotificationRuleResponse> {
    constructor() {
        super("vlp.notification.NotificationRuleResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationRuleDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationRuleResponse>): NotificationRuleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationRuleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationRuleResponse): NotificationRuleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationRuleDTO data */ 2:
                    message.data = NotificationRuleDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationRuleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationRuleDTO data = 2; */
        if (message.data)
            NotificationRuleDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationRuleResponse
 */
export const NotificationRuleResponse = new NotificationRuleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationRuleListResponse$Type extends MessageType<NotificationRuleListResponse> {
    constructor() {
        super("vlp.notification.NotificationRuleListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationRuleDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationRuleListResponse>): NotificationRuleListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<NotificationRuleListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationRuleListResponse): NotificationRuleListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationRuleDTO items */ 2:
                    message.items.push(NotificationRuleDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationRuleListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationRuleDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationRuleDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationRuleListResponse
 */
export const NotificationRuleListResponse = new NotificationRuleListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationRecipientRuleResponse$Type extends MessageType<NotificationRecipientRuleResponse> {
    constructor() {
        super("vlp.notification.NotificationRecipientRuleResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationRecipientRuleDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationRecipientRuleResponse>): NotificationRecipientRuleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationRecipientRuleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationRecipientRuleResponse): NotificationRecipientRuleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationRecipientRuleDTO data */ 2:
                    message.data = NotificationRecipientRuleDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationRecipientRuleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationRecipientRuleDTO data = 2; */
        if (message.data)
            NotificationRecipientRuleDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationRecipientRuleResponse
 */
export const NotificationRecipientRuleResponse = new NotificationRecipientRuleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationTemplateResponse$Type extends MessageType<NotificationTemplateResponse> {
    constructor() {
        super("vlp.notification.NotificationTemplateResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationTemplateDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationTemplateResponse>): NotificationTemplateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationTemplateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationTemplateResponse): NotificationTemplateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationTemplateDTO data */ 2:
                    message.data = NotificationTemplateDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationTemplateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationTemplateDTO data = 2; */
        if (message.data)
            NotificationTemplateDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationTemplateResponse
 */
export const NotificationTemplateResponse = new NotificationTemplateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationTemplateListResponse$Type extends MessageType<NotificationTemplateListResponse> {
    constructor() {
        super("vlp.notification.NotificationTemplateListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationTemplateDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationTemplateListResponse>): NotificationTemplateListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<NotificationTemplateListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationTemplateListResponse): NotificationTemplateListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationTemplateDTO items */ 2:
                    message.items.push(NotificationTemplateDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationTemplateListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationTemplateDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationTemplateDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationTemplateListResponse
 */
export const NotificationTemplateListResponse = new NotificationTemplateListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationPreferenceResponse$Type extends MessageType<NotificationPreferenceResponse> {
    constructor() {
        super("vlp.notification.NotificationPreferenceResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationPreferenceDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationPreferenceResponse>): NotificationPreferenceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationPreferenceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationPreferenceResponse): NotificationPreferenceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationPreferenceDTO data */ 2:
                    message.data = NotificationPreferenceDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationPreferenceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationPreferenceDTO data = 2; */
        if (message.data)
            NotificationPreferenceDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationPreferenceResponse
 */
export const NotificationPreferenceResponse = new NotificationPreferenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationPreferenceListResponse$Type extends MessageType<NotificationPreferenceListResponse> {
    constructor() {
        super("vlp.notification.NotificationPreferenceListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationPreferenceDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationPreferenceListResponse>): NotificationPreferenceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<NotificationPreferenceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationPreferenceListResponse): NotificationPreferenceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationPreferenceDTO items */ 2:
                    message.items.push(NotificationPreferenceDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationPreferenceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationPreferenceDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationPreferenceDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationPreferenceListResponse
 */
export const NotificationPreferenceListResponse = new NotificationPreferenceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MyNotificationsResponse$Type extends MessageType<MyNotificationsResponse> {
    constructor() {
        super("vlp.notification.MyNotificationsResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationMessageDTO },
            { no: 3, name: "deliveries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationDeliveryDTO },
            { no: 4, name: "unread_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "read_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "type_options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationInboxTypeOptionDTO }
        ]);
    }
    create(value?: PartialMessage<MyNotificationsResponse>): MyNotificationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.deliveries = [];
        message.unreadCount = 0;
        message.totalCount = 0;
        message.readCount = 0;
        message.typeOptions = [];
        if (value !== undefined)
            reflectionMergePartial<MyNotificationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MyNotificationsResponse): MyNotificationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationMessageDTO items */ 2:
                    message.items.push(NotificationMessageDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated vlp.notification.NotificationDeliveryDTO deliveries */ 3:
                    message.deliveries.push(NotificationDeliveryDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 unread_count */ 4:
                    message.unreadCount = reader.int32();
                    break;
                case /* int32 total_count */ 5:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 read_count */ 6:
                    message.readCount = reader.int32();
                    break;
                case /* repeated vlp.notification.NotificationInboxTypeOptionDTO type_options */ 7:
                    message.typeOptions.push(NotificationInboxTypeOptionDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MyNotificationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationMessageDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationMessageDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationDeliveryDTO deliveries = 3; */
        for (let i = 0; i < message.deliveries.length; i++)
            NotificationDeliveryDTO.internalBinaryWrite(message.deliveries[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 unread_count = 4; */
        if (message.unreadCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.unreadCount);
        /* int32 total_count = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        /* int32 read_count = 6; */
        if (message.readCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.readCount);
        /* repeated vlp.notification.NotificationInboxTypeOptionDTO type_options = 7; */
        for (let i = 0; i < message.typeOptions.length; i++)
            NotificationInboxTypeOptionDTO.internalBinaryWrite(message.typeOptions[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.MyNotificationsResponse
 */
export const MyNotificationsResponse = new MyNotificationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkNotificationReadResponse$Type extends MessageType<MarkNotificationReadResponse> {
    constructor() {
        super("vlp.notification.MarkNotificationReadResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "marked_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "unread_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<MarkNotificationReadResponse>): MarkNotificationReadResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.markedCount = 0;
        message.unreadCount = 0;
        if (value !== undefined)
            reflectionMergePartial<MarkNotificationReadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MarkNotificationReadResponse): MarkNotificationReadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* int32 marked_count */ 2:
                    message.markedCount = reader.int32();
                    break;
                case /* int32 unread_count */ 3:
                    message.unreadCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MarkNotificationReadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 marked_count = 2; */
        if (message.markedCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.markedCount);
        /* int32 unread_count = 3; */
        if (message.unreadCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.unreadCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.MarkNotificationReadResponse
 */
export const MarkNotificationReadResponse = new MarkNotificationReadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMyReadNotificationsResponse$Type extends MessageType<DeleteMyReadNotificationsResponse> {
    constructor() {
        super("vlp.notification.DeleteMyReadNotificationsResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "deleted_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "unread_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "read_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteMyReadNotificationsResponse>): DeleteMyReadNotificationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.deletedCount = 0;
        message.unreadCount = 0;
        message.readCount = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteMyReadNotificationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteMyReadNotificationsResponse): DeleteMyReadNotificationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* int32 deleted_count */ 2:
                    message.deletedCount = reader.int32();
                    break;
                case /* int32 unread_count */ 3:
                    message.unreadCount = reader.int32();
                    break;
                case /* int32 read_count */ 4:
                    message.readCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteMyReadNotificationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 deleted_count = 2; */
        if (message.deletedCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.deletedCount);
        /* int32 unread_count = 3; */
        if (message.unreadCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.unreadCount);
        /* int32 read_count = 4; */
        if (message.readCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.readCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.DeleteMyReadNotificationsResponse
 */
export const DeleteMyReadNotificationsResponse = new DeleteMyReadNotificationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDeviceResponse$Type extends MessageType<NotificationDeviceResponse> {
    constructor() {
        super("vlp.notification.NotificationDeviceResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationDeviceDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationDeviceResponse>): NotificationDeviceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationDeviceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDeviceResponse): NotificationDeviceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationDeviceDTO data */ 2:
                    message.data = NotificationDeviceDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDeviceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationDeviceDTO data = 2; */
        if (message.data)
            NotificationDeviceDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDeviceResponse
 */
export const NotificationDeviceResponse = new NotificationDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDeliveryListResponse$Type extends MessageType<NotificationDeliveryListResponse> {
    constructor() {
        super("vlp.notification.NotificationDeliveryListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationDeliveryDTO },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<NotificationDeliveryListResponse>): NotificationDeliveryListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<NotificationDeliveryListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDeliveryListResponse): NotificationDeliveryListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationDeliveryDTO items */ 2:
                    message.items.push(NotificationDeliveryDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDeliveryListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationDeliveryDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationDeliveryDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDeliveryListResponse
 */
export const NotificationDeliveryListResponse = new NotificationDeliveryListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertIncidentResponse$Type extends MessageType<AlertIncidentResponse> {
    constructor() {
        super("vlp.notification.AlertIncidentResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => AlertIncidentDTO }
        ]);
    }
    create(value?: PartialMessage<AlertIncidentResponse>): AlertIncidentResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AlertIncidentResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertIncidentResponse): AlertIncidentResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.AlertIncidentDTO data */ 2:
                    message.data = AlertIncidentDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertIncidentResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.AlertIncidentDTO data = 2; */
        if (message.data)
            AlertIncidentDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertIncidentResponse
 */
export const AlertIncidentResponse = new AlertIncidentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertIncidentListResponse$Type extends MessageType<AlertIncidentListResponse> {
    constructor() {
        super("vlp.notification.AlertIncidentListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AlertIncidentDTO },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AlertIncidentListResponse>): AlertIncidentListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AlertIncidentListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertIncidentListResponse): AlertIncidentListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.AlertIncidentDTO items */ 2:
                    message.items.push(AlertIncidentDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertIncidentListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.AlertIncidentDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            AlertIncidentDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertIncidentListResponse
 */
export const AlertIncidentListResponse = new AlertIncidentListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertSilenceResponse$Type extends MessageType<AlertSilenceResponse> {
    constructor() {
        super("vlp.notification.AlertSilenceResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => AlertSilenceDTO }
        ]);
    }
    create(value?: PartialMessage<AlertSilenceResponse>): AlertSilenceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AlertSilenceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertSilenceResponse): AlertSilenceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.AlertSilenceDTO data */ 2:
                    message.data = AlertSilenceDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertSilenceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.AlertSilenceDTO data = 2; */
        if (message.data)
            AlertSilenceDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertSilenceResponse
 */
export const AlertSilenceResponse = new AlertSilenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertSilenceListResponse$Type extends MessageType<AlertSilenceListResponse> {
    constructor() {
        super("vlp.notification.AlertSilenceListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AlertSilenceDTO }
        ]);
    }
    create(value?: PartialMessage<AlertSilenceListResponse>): AlertSilenceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<AlertSilenceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertSilenceListResponse): AlertSilenceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.AlertSilenceDTO items */ 2:
                    message.items.push(AlertSilenceDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlertSilenceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.AlertSilenceDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            AlertSilenceDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.AlertSilenceListResponse
 */
export const AlertSilenceListResponse = new AlertSilenceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSendNotificationResponse$Type extends MessageType<TestSendNotificationResponse> {
    constructor() {
        super("vlp.notification.TestSendNotificationResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "rendered_subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rendered_body", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestSendNotificationResponse>): TestSendNotificationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.renderedSubject = "";
        message.renderedBody = "";
        if (value !== undefined)
            reflectionMergePartial<TestSendNotificationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestSendNotificationResponse): TestSendNotificationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* string rendered_subject */ 2:
                    message.renderedSubject = reader.string();
                    break;
                case /* string rendered_body */ 3:
                    message.renderedBody = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestSendNotificationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string rendered_subject = 2; */
        if (message.renderedSubject !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.renderedSubject);
        /* string rendered_body = 3; */
        if (message.renderedBody !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.renderedBody);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.TestSendNotificationResponse
 */
export const TestSendNotificationResponse = new TestSendNotificationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNotificationMailProfilesRequest$Type extends MessageType<ListNotificationMailProfilesRequest> {
    constructor() {
        super("vlp.notification.ListNotificationMailProfilesRequest", [
            { no: 1, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "include_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListNotificationMailProfilesRequest>): ListNotificationMailProfilesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationUnitId = 0;
        message.includeDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<ListNotificationMailProfilesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListNotificationMailProfilesRequest): ListNotificationMailProfilesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organization_unit_id */ 1:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* bool include_disabled */ 2:
                    message.includeDisabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListNotificationMailProfilesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organization_unit_id = 1; */
        if (message.organizationUnitId !== 0)
            writer.tag(1, WireType.Varint).int64(message.organizationUnitId);
        /* bool include_disabled = 2; */
        if (message.includeDisabled !== false)
            writer.tag(2, WireType.Varint).bool(message.includeDisabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.ListNotificationMailProfilesRequest
 */
export const ListNotificationMailProfilesRequest = new ListNotificationMailProfilesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveNotificationMailCredentialRequest$Type extends MessageType<SaveNotificationMailCredentialRequest> {
    constructor() {
        super("vlp.notification.SaveNotificationMailCredentialRequest", [
            { no: 1, name: "notification_mail_profile_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SaveNotificationMailCredentialRequest>): SaveNotificationMailCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationMailProfileId = 0;
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<SaveNotificationMailCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaveNotificationMailCredentialRequest): SaveNotificationMailCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_mail_profile_id */ 1:
                    message.notificationMailProfileId = reader.int64().toNumber();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaveNotificationMailCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_mail_profile_id = 1; */
        if (message.notificationMailProfileId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationMailProfileId);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.SaveNotificationMailCredentialRequest
 */
export const SaveNotificationMailCredentialRequest = new SaveNotificationMailCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestNotificationMailProfileRequest$Type extends MessageType<TestNotificationMailProfileRequest> {
    constructor() {
        super("vlp.notification.TestNotificationMailProfileRequest", [
            { no: 1, name: "notification_mail_profile_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "send_test_message", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TestNotificationMailProfileRequest>): TestNotificationMailProfileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationMailProfileId = 0;
        message.sendTestMessage = false;
        if (value !== undefined)
            reflectionMergePartial<TestNotificationMailProfileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestNotificationMailProfileRequest): TestNotificationMailProfileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_mail_profile_id */ 1:
                    message.notificationMailProfileId = reader.int64().toNumber();
                    break;
                case /* bool send_test_message */ 2:
                    message.sendTestMessage = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestNotificationMailProfileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_mail_profile_id = 1; */
        if (message.notificationMailProfileId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationMailProfileId);
        /* bool send_test_message = 2; */
        if (message.sendTestMessage !== false)
            writer.tag(2, WireType.Varint).bool(message.sendTestMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.TestNotificationMailProfileRequest
 */
export const TestNotificationMailProfileRequest = new TestNotificationMailProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationMailProfileResponse$Type extends MessageType<NotificationMailProfileResponse> {
    constructor() {
        super("vlp.notification.NotificationMailProfileResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "data", kind: "message", T: () => NotificationMailProfileDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationMailProfileResponse>): NotificationMailProfileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationMailProfileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationMailProfileResponse): NotificationMailProfileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* vlp.notification.NotificationMailProfileDTO data */ 2:
                    message.data = NotificationMailProfileDTO.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationMailProfileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* vlp.notification.NotificationMailProfileDTO data = 2; */
        if (message.data)
            NotificationMailProfileDTO.internalBinaryWrite(message.data, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationMailProfileResponse
 */
export const NotificationMailProfileResponse = new NotificationMailProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationMailProfileListResponse$Type extends MessageType<NotificationMailProfileListResponse> {
    constructor() {
        super("vlp.notification.NotificationMailProfileListResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationMailProfileDTO }
        ]);
    }
    create(value?: PartialMessage<NotificationMailProfileListResponse>): NotificationMailProfileListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<NotificationMailProfileListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationMailProfileListResponse): NotificationMailProfileListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* repeated vlp.notification.NotificationMailProfileDTO items */ 2:
                    message.items.push(NotificationMailProfileDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationMailProfileListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated vlp.notification.NotificationMailProfileDTO items = 2; */
        for (let i = 0; i < message.items.length; i++)
            NotificationMailProfileDTO.internalBinaryWrite(message.items[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationMailProfileListResponse
 */
export const NotificationMailProfileListResponse = new NotificationMailProfileListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestNotificationMailProfileResponse$Type extends MessageType<TestNotificationMailProfileResponse> {
    constructor() {
        super("vlp.notification.TestNotificationMailProfileResponse", [
            { no: 1, name: "status", kind: "message", T: () => ActionResponse },
            { no: 2, name: "result_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestNotificationMailProfileResponse>): TestNotificationMailProfileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resultCode = "";
        if (value !== undefined)
            reflectionMergePartial<TestNotificationMailProfileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestNotificationMailProfileResponse): TestNotificationMailProfileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.ActionResponse status */ 1:
                    message.status = ActionResponse.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* string result_code */ 2:
                    message.resultCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestNotificationMailProfileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* common.ActionResponse status = 1; */
        if (message.status)
            ActionResponse.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string result_code = 2; */
        if (message.resultCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resultCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.TestNotificationMailProfileResponse
 */
export const TestNotificationMailProfileResponse = new TestNotificationMailProfileResponse$Type();
